import { useEffect, useRef } from 'react';
import { useDebounce, useUnmount } from 'react-use';

const useSearchBar = (props) => {
  const {
    value,
    visible,
    focusOnOpen = true,
    timeoutMs,
    onClear,
    onChange,
    onSearch,
  } = props;
  const inputRef = useRef(null);

  const [, cancel] = useDebounce(
    () => {
      if (value.trim().length > 0) {
        onSearch(value);
      }
    },
    timeoutMs,
    [value],
  );

  useUnmount(() => cancel());

  useEffect(() => {
    if (visible && focusOnOpen && inputRef.current) {
      inputRef.current.focus();
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 300);
    }
  }, [visible, focusOnOpen]);

  const handleChange = ({ currentTarget }) => {
    onChange(currentTarget.value);
  };

  const handleClear = (event) => {
    inputRef.current.focus();

    // onChange(event, '', 'clear');
    onClear(event, '', 'clear');
  };

  const handleSearch = (event) => {
    event.preventDefault();
    cancel();

    onSearch(value);
  };

  return {
    inputRef,
    value,
    onChange: handleChange,
    onClear: handleClear,
    onSearch: handleSearch,
  };
};

export default useSearchBar;
